import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"
import Fade from "react-reveal/Fade"

const Press = ({ isLangEn }) => {
  const data = useStaticQuery(graphql`
    query {
      imageEspn: file(relativePath: { eq: "press-espn.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 250) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageVariety: file(relativePath: { eq: "press-variety.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 250) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageScreenDaily: file(relativePath: { eq: "press-screendaily.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 250) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imagePeople: file(relativePath: { eq: "press-people.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 250) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageNYT: file(relativePath: { eq: "press-newyorktimes.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 250) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageHuffpost: file(relativePath: { eq: "press-huffpost.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 250) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageNatalie: file(relativePath: { eq: "press-natalie.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 250) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageEiga: file(relativePath: { eq: "press-eiga.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 250) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  const num = []
  for (let i = 0; i < 8; ++i) {
    num.push(i * 150)
  }

  return (
    <>
      {isLangEn ? (
        <div className="press__items container">
          <Fade bottom delay={num[0]} duration={800} distance={"20px"}>
            <div className="press__item">
              <a
                href="https://www.nytimes.com/2024/04/05/world/asia/japan-documentary-films-ema-ryan-yamazaki.html?unlocked_article_code=1.iE0.krY_.9jBtxkysQOYR"
                className="press__item__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.imageNYT.childImageSharp.fluid}
                  alt="New York Times"
                  className="press__item__image"
                />
                <div className="press__item__caption">
                  Documentary Filmmaker Explores Japan's Rigorous Education
                  Rituals
                </div>
              </a>
            </div>
          </Fade>
          <Fade bottom delay={num[1]} duration={800} distance={"20px"}>
            <div className="press__item">
              <a
                href="https://variety.com/2018/film/asia/eric-nyari-ema-ryan-yamazaki-change-japan-film-1203035237/"
                className="press__item__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.imageVariety.childImageSharp.fluid}
                  alt="VARIETY"
                  className="press__item__image"
                />
                <div className="press__item__caption">
                  Eric Nyari and Ema Ryan Yamazaki: Emblems of Change in
                  Japanese Film
                </div>
              </a>
            </div>
          </Fade>
          <Fade bottom delay={num[2]} duration={800} distance={"20px"}>
            <div className="press__item">
              <a
                href="https://www.screendaily.com/reviews/black-box-diaries-sundance-review/5189499.article"
                className="press__item__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.imageScreenDaily.childImageSharp.fluid}
                  alt="SCREEN DAILY"
                  className="press__item__image"
                />
                <div className="press__item__caption">
                  ‘Black Box Diaries’: Sundance Review
                </div>
              </a>
            </div>
          </Fade>
          <Fade bottom delay={num[3]} duration={800} distance={"20px"}>
            <div className="press__item">
              <a
                href="https://people.com/movies/curious-georges-escape-from-nazi-germany-revealed-in-new-documentary/"
                className="press__item__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.imagePeople.childImageSharp.fluid}
                  alt="People"
                  className="press__item__image"
                />
                <div className="press__item__caption">
                  Curious George Creators’ Incredible Escape from Nazi Germany
                  Revealed in New Documentary
                </div>
              </a>
            </div>
          </Fade>
          <Fade bottom delay={num[4]} duration={800} distance={"20px"}>
            <div className="press__item">
              <a
                href="https://www.espn.com/mlb/story/_/id/29370563/new-baseball-film-captures-tournament-made-shohei-ohtani-yusei-kikuchi-stars"
                className="press__item__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.imageEspn.childImageSharp.fluid}
                  alt="ESPN"
                  className="press__item__image"
                />
                <div className="press__item__caption">
                  New baseball film captures the tournament that made Shohei
                  Ohtani, Yusei Kikuchi stars
                </div>
              </a>
            </div>
          </Fade>
          <Fade bottom delay={num[5]} duration={800} distance={"20px"}>
            <div className="press__item">
              <a
                href="https://www.huffpost.com/entry/curious-george-documentary_n_57b2009de4b007c36e4f8f78?guccounter=1"
                className="press__item__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.imageHuffpost.childImageSharp.fluid}
                  alt="HUFFPOST"
                  className="press__item__image"
                />
                <div className="press__item__caption">
                  Meet The Extraordinary Husband-Wife Duo Behind ‘Curious
                  George’
                </div>
              </a>
            </div>
          </Fade>
        </div>
      ) : (
        <div className="press__items container-narrow">
          <div className="press__container">
            <Fade bottom delay={num[0]} duration={800} distance={"20px"}>
              <div className="press__item__txt">
                <a
                  href="https://www.sponichi.co.jp/entertainment/news/2020/09/04/kiji/20200903s00041000536000c.html"
                  className="press__item__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="ar-right">&#187;</span>
                  中止の夏に映画「甲子園」“異例ヒット”横浜＆岩手で好稼働！横浜隼人・水谷監督と花巻東・佐々木監督の絆（スポニチ）
                </a>
              </div>
            </Fade>
            <Fade bottom delay={num[1]} duration={800} distance={"20px"}>
              <div className="press__item__txt">
                <a
                  href="https://www.huffingtonpost.jp/entry/story_jp_5f8950a1c5b66ee9a5eeb6ef"
                  className="press__item__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="ar-right">&#187;</span>
                  甲子園は個性を殺す、古臭いものなのか？イチローファンの監督が問い直す、私たちの社会（HUFFPOST）
                </a>
              </div>
            </Fade>

            <Fade bottom delay={num[2]} duration={800} distance={"20px"}>
              <div className="press__item__txt">
                <a
                  href="https://sportsbull.jp/p/846347/"
                  className="press__item__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="ar-right">&#187;</span>
                  高校野球との出会いは運命
                  山崎エマ監督が伝えたかったこととは?（SPORTS BULL）
                </a>
              </div>
            </Fade>

            <Fade bottom delay={num[3]} duration={800} distance={"20px"}>
              <div className="press__item__txt">
                <a
                  href="https://cinemore.jp/jp/news-feature/1603/article_p5.html"
                  className="press__item__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="ar-right">&#187;</span>
                  『甲子園：フィールド・オブ・ドリームス』山崎エマ監督　NYから帰国後、高校野球が日本社会の縮図に見えたんです。（CINEMORE）
                </a>
              </div>
            </Fade>

            <Fade bottom delay={num[4]} duration={800} distance={"20px"}>
              <div className="press__item__txt">
                <a
                  href="https://www.asahi.com/articles/ASM9F7VHMM9FUTIL05P.html"
                  className="press__item__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="ar-right">&#187;</span>
                  イチローこそ人生の師　影響力記録する映像作家が追う夢（朝日新聞デジタル）
                </a>
              </div>
            </Fade>
            <Fade bottom delay={num[5]} duration={800} distance={"20px"}>
              <div className="press__item__txt">
                <a
                  href="https://natalie.mu/eiga/news/291452"
                  className="press__item__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="ar-right">&#187;</span>
                  「おさるのジョージ」著者夫妻のドキュメンタリーを監督が語る「使命だと覚悟した」（映画ナタリー）
                </a>
              </div>
            </Fade>
          </div>
        </div>
      )}
    </>
  )
}

export default Press
